import { formatTime } from '../../filter'

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this

	let arr = [
		{
			label: '派单人姓名',
			value: order.creatorName,
		},
		{
			label: '派单人电话',
			value: order.creatorPhone,
		},
		{
			label: '派单时间',
			value: formatTime(order.createTime),
		},
	]
	let visitorSignature = ''
	if (injured.visitorInfo) {
		visitorSignature = injured.visitorInfo.visitorSignature
		if (visitorSignature) {
			const cardNo = injured.visitorInfo.visitorCardNo
			if (cardNo) {
				visitorSignature = `${visitorSignature}（${cardNo}）`
			}
		}
	}
	arr = arr.concat([
		{
			label: '作业人员姓名',
			value: visitorSignature,
		},
		{
			label: '作业人员电话',
			value: injured.visitorInfo && injured.visitorInfo.visitorPhone,
		},
		{
			label: '作业时间',
			value: formatTime(order.visitTime),
		},
		{
			label: '审核人姓名',
			value: order.auditorName,
		},
		{
			label: '审核人电话',
			value: order.auditorPhone,
		},
		{
			label: '审核时间',
			value: formatTime(order.auditTime),
		},
	])

	if (
		this.isWholeProcess &&
		(this.isResurvey || this.isMotion || this.isNewMotion)
	) {
		arr.push(
			{
				label: '委托人姓名',
				value: order.clientName,
			},
			{
				label: '委托人电话',
				value: order.clientPhone,
			}
		)
	}

	return {
		title: '任务人员信息',
		children: arr,
		span: {
			审核时间: 12,
			作业时间: 12,
			派单时间: 12,
		},
	}
}
